import React from 'react';

const MaintenancePage = () => {
    return (
        <iframe 
            src="/maintenance.html" 
            title="Maintenance" 
            style={{ 
                width: '100%', 
                height: '100vh', 
                border: 'none', 
                position: 'fixed', 
                top: 0, 
                left: 0,
                zIndex: 9999
            }}
        />
    );
};

export default MaintenancePage;